
import Component from '../../../assets/scripts/modules/component';
import {pagination} from '../../../assets/scripts/modules/pagination';
import State from '../../../assets/scripts/modules/state';

const Swiper = require('swiper/dist/js/swiper.min');

// const forceLoadImage = instance => {
//   const slide = instance.slides[instance.activeIndex];
//   const image = slide.querySelector('.picture, .background-image');
//
//   try {
//     if (!image.classList.contains('has-loaded')) {
//       image.forceLoad();
//     }
//   } catch(e) {
//     //
//   }
// };

const swiperDefaults = (gridSlider) => {
  return {
    autoPlay: false,
    grabCursor: false,
    keyboard: true,
    navigation: {
      nextEl: gridSlider.buttonNext,
      prevEl: gridSlider.buttonPrev,
    },
    pagination: {
      el: gridSlider.pagination,
      clickable: true,
      type: 'custom',
      renderCustom: pagination,
    },
    resistanceRatio: 0,
    roundLengths: true, // Prevents dragging fuzzyness
    setWrapperSize: true, // Fix for Firefox / IE11 for flex icm. padding-bottom
    touchRatio: 1,
    // onTransitionStart: forceLoadImage,
    // onTransitionEnd: forceLoadImage,
  };
};

const swiperMultiSlidesPerView = {
  slidesPerView: 'auto',
  spaceBetween: 30,
};

class GridSlider extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.container = this.element.querySelector('.swiper-container');
    this.pagination = this.element.querySelector('.swiper-pagination');
    this.buttonPrev = this.element.querySelector('.swiper-button--prev');
    this.buttonNext = this.element.querySelector('.swiper-button--next');
    this.gutterMeasure = this.element.querySelector('[data-role="grid-slider--gutter-measure"]');

    this.instance = null;
    this.isMobileVersion = null;

    window.requestAnimationFrame(() => this.initSwiper());

  }

  initSwiper() {

    this.instance = this.getNewSwiperLandscape();

    window.addEventListener('resize', this.resize.bind(this));
    this.resize();

  }

  getNewSwiperLandscape() {

    const config = {};

    Object.assign(config, swiperDefaults(this), swiperMultiSlidesPerView);

    return new Swiper(this.container, config);

  }

  getNewSwiperMobile() {

    const config = {};
    Object.assign(config, swiperDefaults(this));

    return new Swiper(this.container, config);

  }

  resize() {

    let swiperCreator = null;

    if (this.isMobileVersion === null) {
      swiperCreator = State.isLandscape() ? this.getNewSwiperLandscape : this.getNewSwiperMobile;
    } else {
      if (this.isMobileVersion && State.isLandscape()) {
        this.isMobileVersion = false;
        swiperCreator = this.getNewSwiperLandscape;
      } else if (!this.isMobileVersion && !State.isLandscape()) {
        this.isMobileVersion = true;
        swiperCreator = this.getNewSwiperMobile;
      }
    }

    if (swiperCreator !== null) {
      if (this.instance !== null) {
        this.instance.destroy();
      }

      this.instance = swiperCreator.bind(this)();
    }

    this.instance.params.spaceBetween = this.gutterMeasure.getBoundingClientRect().width;
  }

}

for (const element of document.querySelectorAll('.grid-slider')) {
  element.instance = new GridSlider('grid-slider', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/organisms/grid-slider/grid-slider.js